const state = {
  allow: false,
  wait: false
}

export default state
